/**
 * DREAMMANE CUSTOM — Variant Picker Price Fix (v2)
 * --------------------------------------------------------------------
 * Problem: Wenn "Alle Farben" aktiv ist und der User die Länge ändert,
 * wird manchmal kein Preis angezeigt, weil die Farb-Option nicht als
 * "ausgewählt" erkannt wird.
 *
 * Lösung: Wir stellen sicher, dass immer mindestens eine Farb-Radio
 * gecheckt ist. Wenn nach einem variant-picker Rerender keine Radio
 * einer Options-Position gecheckt ist, checken wir die erste sichtbare
 * (nicht gefilterte), nicht-disabled Option.
 *
 * v2-Fixes:
 * - Nach programmatischem Checken wird ein change-Event dispatcht,
 *   damit der Theme-VariantPicker Preis + Variant-ID nachzieht.
 *   (Vorher: UI zeigte Auswahl, aber form.id blieb stale → falsche
 *   Variante konnte in den Warenkorb gehen.)
 * - Fallback überspringt Farben, die der Farbfilter gerade ausblendet
 *   (.is-filtered-out am Label).
 * - Reentrancy-Guard: der dispatchte change löst einen Rerender aus,
 *   der wieder hier landet — wir reagieren nicht auf uns selbst.
 */
(function () {
  'use strict';

  var isDispatching = false;

  function labelFor(input) {
    if (!input.id) return null;
    var scope = input.closest('fieldset') || input.form || document;
    return scope.querySelector('label[for="' + CSS.escape(input.id) + '"]');
  }

  function isFilteredOut(input) {
    var label = labelFor(input);
    return !!(label && label.classList.contains('is-filtered-out'));
  }

  function ensureAllOptionsChecked(form) {
    if (!form || isDispatching) return;

    var inputs = Array.from(form.elements).filter(function (el) {
      return el.matches && el.matches('input[data-option-position]');
    });

    if (!inputs.length) return;

    // Gruppiere nach Option-Position
    var positions = {};
    inputs.forEach(function (input) {
      var pos = input.getAttribute('data-option-position');
      if (!positions[pos]) positions[pos] = [];
      positions[pos].push(input);
    });

    Object.keys(positions).forEach(function (pos) {
      var group = positions[pos];
      var hasChecked = group.some(function (input) { return input.checked; });
      if (hasChecked) return;

      // Bevorzugt: nicht-disabled UND nicht vom Farbfilter ausgeblendet.
      // Fallback: irgendeine nicht-disabled Option.
      var fallback = group.find(function (input) {
        return !input.disabled && !isFilteredOut(input);
      }) || group.find(function (input) {
        return !input.disabled;
      });

      if (fallback) {
        fallback.checked = true;
        // WICHTIG: Theme-VariantPicker hört auf change (Delegate auf body).
        // Ohne Dispatch bleiben Preis und form.id stale.
        isDispatching = true;
        try {
          fallback.dispatchEvent(new Event('change', { bubbles: true }));
        } finally {
          // Erst nach dem aktuellen Task wieder freigeben — der durch den
          // change ausgelöste Rerender kommt asynchron (fetch), aber ein
          // synchroner Re-Entry über Event-Handler ist damit abgedeckt.
          setTimeout(function () { isDispatching = false; }, 0);
        }
      }
    });
  }

  // Nach jedem variant-picker Rerender: sicherstellen dass alle Optionen
  // gecheckt sind. (Seit dem Morph-Fix wird der Haupt-Picker nicht mehr
  // ersetzt — der Observer greift v.a. noch für Quick-Buy-Modal-Replaces.)
  function onDomChange(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var node = m.addedNodes[j];
        if (node.nodeType !== 1) continue;

        var isPicker = (node.matches && node.matches('variant-picker, [data-block-type="variant-picker"]'));
        var hasPicker = !isPicker && node.querySelector && node.querySelector('variant-picker, [data-block-type="variant-picker"]');

        if (isPicker || hasPicker) {
          var picker = isPicker ? node : hasPicker;
          var vp = picker.closest('variant-picker') || picker.querySelector('variant-picker') || picker;
          var formId = vp.getAttribute && vp.getAttribute('form-id');
          if (formId && document.forms[formId]) {
            ensureAllOptionsChecked(document.forms[formId]);
          }
        }
      }
    }
  }

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(onDomChange);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initAll() {
    document.querySelectorAll('variant-picker').forEach(function (vp) {
      var formId = vp.getAttribute('form-id');
      if (formId && document.forms[formId]) {
        ensureAllOptionsChecked(document.forms[formId]);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
